// extracted by mini-css-extract-plugin
export default {"page":"Page_page__PfY4TnOF","title":"Page_title__fZH7091A"};